import React from "react";
import { Tab, Tabs } from "@mui/material";

export const PromotionsBookTabs = ({ books = [], selectedBookId, onChange }) => (
  <div className="promotions-page__tabs-row">
    <Tabs
      value={selectedBookId || false}
      onChange={(_e, value) => onChange?.(value)}
      variant="scrollable"
      scrollButtons="auto"
      className="promotions-page__tabs"
    >
      {books.map((book) => (
        <Tab key={book._id} label={book.name} value={book._id} />
      ))}
    </Tabs>
  </div>
);
